/* global axios */
import ApiClient from './ApiClient';

class TalkviaPortfolioManagementAPI extends ApiClient {
  constructor() {
    super('talkvia_portfolio_management', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }
}

export default new TalkviaPortfolioManagementAPI();
